import React from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  title: string;
  image: string;
  alt: string;
}
export function PageHero({
  title,
  image,
  alt
}: PageHeroProps) {
  return <div className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-144">
      <div className="absolute inset-0 z-0" data-id="element-145">
        <img src={image} alt={alt} className="w-full h-full object-cover object-center" data-id="element-146" />
        <div className="absolute inset-0 bg-brand-hunter/70 mix-blend-multiply" data-id="element-147"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal/90 via-brand-charcoal/40 to-transparent" data-id="element-148"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-150">
          <div className="flex items-center justify-center space-x-2 mb-4" data-id="element-151">
            <div className="h-px w-8 bg-brand-leather" data-id="element-152"></div>
            <span className="text-brand-bone uppercase tracking-widest text-xs font-semibold" data-id="element-153">
              Kjergaard Sports
            </span>
            <div className="h-px w-8 bg-brand-leather" data-id="element-154"></div>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-brand-offwhite leading-tight" data-id="element-155">
            {title}
          </h1>
        </motion.div>
      </div>
    </div>;
}